<template>
  <div>
    <v-card>
      <v-card-title>
        Días inhábiles
        <v-spacer />
        <v-btn @click="addDisabledDate" color="success" dark>
          Agregar día inhábil
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="dates"
          :items-per-page="10"
          class="elevation-1"
        >
          <template #item.options="{ item }">
            <v-btn small @click="removeDate(item.date)" color="error">
              <v-icon>mdi-trash-can</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <AddDisabledDateDialog
      :is-open="isAddDisabledDateDialogOpen"
      @close="refreshTable"
    />
  </div>
</template>

<script>
import AddDisabledDateDialog from "@/components/Dialogs/AddDisabledDateDialog";

export default {
  components: { AddDisabledDateDialog },
  data() {
    return {
      headers: [
        { text: "Fecha", value: "date" },
        { text: "Opciones", value: "options" },
      ],
      dates: [],
      form: {},
      isAddDisabledDateDialogOpen: false,
    };
  },
  methods: {
    getItems() {
      this.openLoader();

      const request = this.sendRequest(
        `${this.$store.state.apiUrl}settings/disabled-dates`,
        this.form
      );
      request
        .then(({ data }) => {
          this.dates = data;
        })
        .finally(this.closeLoader());
    },
    addDisabledDate() {
      this.isAddDisabledDateDialogOpen = true;
    },
    refreshTable() {
      this.isAddDisabledDateDialogOpen = false;
      this.getItems();
    },
    async removeDate(date) {
      this.openLoader();

      try {
        await this.deleteRequest(`settings/disabled-dates/${date}`);

        this.showSuccessMessage("Fecha eliminada");
      } catch (error) {
        this.showErrorMessage(error.message);
      } finally {
        this.closeLoader();
        this.getItems();
      }
    },
  },
  mounted() {
    this.getItems();
  },
};
</script>
